// @flow
import compose from 'recompose/compose';
import branch from 'recompose/branch';
import renderComponent from 'recompose/renderComponent';
import both from 'ramda/es/both';

import InformsStandart from './InformsStandart';
import InformsPacks from './InformsPacks';
import InformsStandartSms from './InformsStandartSms';

import {
  isSmsSubscribeActive,
  isMonthly,
  isBundle,
} from './reasons';


export default compose(
  // Месячная подписка с отдельными пакетами на смс
  branch(
    both(isMonthly, isSmsSubscribeActive),
    renderComponent(InformsStandartSms)
  ),
  // Пакетный тариф
  branch(
    isBundle,
    renderComponent(InformsPacks)
  )
)(InformsStandart);
